<header>
  <div class="d-flex justify-content-between m-header align-items-center row no-gutters">
    <div class="col">
      <button class="btn btn-link m-header-link p-0" (click)="restartClick()"><i class="fa fa-undo" aria-hidden="true"></i><span class="d-none mx-1 d-sm-inline-block">{{'COMMON.UNDO'| translate}}</span></button>
      <!-- <button class="btn btn-link m-header-link p-0" (click)="restartClick()"><img src="assets/images/icons/undo.png"><span class="d-none d-sm-inline-block">&nbsp;{{'COMMON.UNDO'| translate}}</span></button> -->
    </div>
    <div class="col text-center">
      <a href="https://www.mizrahi-tefahot.co.il">
        <img src="assets/images/new-logo.png" class="m-logo" alt="{{'COMMON.LOGO_ALT' | translate}}" />
      </a>
    </div>
    <div class="col text-left">
      <!-- <button  *ngIf="showContactUs" class="btn btn-link m-header-link p-0" (click)="openHelpDialog()"><img src="assets/images/icons/service.png"><span class="d-none mx-1 d-sm-inline-block">{{'START.CHAT'| translate}}</span></button> -->
    </div>
  </div>
</header>


// WEBPACK FOOTER //
// ./src/app/header/header.component.html